import { JobBoardCredentialKey } from '@recruitee/job-boards-types';

export const JOB_BOARD_CREDENTIAL_KEY_TRANSLATION_MAP: {
  [key in JobBoardCredentialKey]: { name: string; placeholder: string };
} = {
  [JobBoardCredentialKey.FigaroClassifiedsCustomerId]: {
    name: 'app.job_boards.settings.credentials.keys.figaro_classifieds_customer_id',
    placeholder: 'app.job_boards.settings.credentials.placeholders.figaro_classifieds_customer_id',
  },
  [JobBoardCredentialKey.IndeedWebsite]: {
    name: 'app.job_boards.settings.credentials.keys.indeed_website',
    placeholder: 'app.job_boards.settings.credentials.placeholders.indeed_website',
  },
  [JobBoardCredentialKey.IndeedEmail]: {
    name: 'app.job_boards.settings.credentials.keys.indeed_email',
    placeholder: 'app.job_boards.settings.credentials.placeholders.indeed_email',
  },
  [JobBoardCredentialKey.LinkedinCompanyId]: {
    name: 'app.job_boards.settings.credentials.keys.linkedin_company_id',
    placeholder: 'app.job_boards.settings.credentials.placeholders.linkedin_company_id',
  },
  [JobBoardCredentialKey.LinkedinPosterEmail]: {
    name: 'app.job_boards.settings.credentials.keys.linkedin_poster_email',
    placeholder: 'app.job_boards.settings.credentials.placeholders.linkedin_poster_email',
  },
  [JobBoardCredentialKey.JobCloudProduct]: {
    name: 'app.job_boards.settings.credentials.keys.jobcloud_product',
    placeholder: 'app.job_boards.settings.credentials.placeholders.jobcloud_product',
  },
  [JobBoardCredentialKey.JobCloudCompanyId]: {
    name: 'app.job_boards.settings.credentials.keys.jobcloud_company_id',
    placeholder: 'app.job_boards.settings.credentials.placeholders.jobcloud_company_id',
  },
  [JobBoardCredentialKey.WorkInStartupsCompanyId]: {
    name: 'app.job_boards.settings.credentials.keys.work_in_startups_company_id',
    placeholder: 'app.job_boards.settings.credentials.placeholders.work_in_startups_company_id',
  },
  [JobBoardCredentialKey.DataRockstarsCompanyId]: {
    name: 'app.job_boards.settings.credentials.keys.datarockstars_company_id',
    placeholder: 'app.job_boards.settings.credentials.placeholders.datarockstars_company_id',
  },
};

export const JOB_BOARD_LINKEDIN_TERMS_AND_CONDITIONS_URL =
  'https://www.linkedin.com/legal/jobs-terms-conditions';
